(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iid-privacy-controls"] && !Shopify.designMode) return;
  try {
    function initializeIidPrivacyControls(root) {
    root.querySelectorAll('[data-iid-privacy-controls]').forEach((control) => {
      if (control.dataset.initialized) return;
      control.dataset.initialized = 'true';
      const button = control.querySelector('[data-iid-privacy-open]');
      const status = control.querySelector('[data-iid-privacy-status]');
      if (!button || !status) return;
      button.addEventListener('click', async () => {
        button.disabled = true;
        status.textContent = status.dataset.loading;
        let timeout;
        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Unavailable');
          await Promise.race([
            window.privacyBanner.showPreferences(),
            new Promise((_, reject) => {
              timeout = window.setTimeout(() => reject(new Error('Timeout')), 10000);
            })
          ]);
          status.textContent = status.dataset.opened;
        } catch {
          status.textContent = status.dataset.unavailable;
        } finally {
          window.clearTimeout(timeout);
          button.disabled = false;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeIidPrivacyControls(document), { once: true });
  } else {
    initializeIidPrivacyControls(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeIidPrivacyControls(event.target));
  } catch(e) { console.error(e); }
})();

})();
